import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  DoCheck,
  ChangeDetectionStrategy,
  Output,
  EventEmitter
} from "@angular/core";
import { QuizReviewService } from "./quiz-review.service";

import * as $ from "jquery";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { EncriptDecriptService } from "../../../../../services/encriptdecript";

@Component({
  selector: "app-quiz-review",
  templateUrl: "./quiz-review.component.html",
  styleUrls: ["./quiz-review.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuizReviewComponent implements OnInit, DoCheck {
  @Input() userObject: any;
  @Input() lessonObject: any;
  @Input() listOfAttempts: any;
  public quizReviewObject;
  private previousLessonObject: any;
  public selectedAttemp: any;
  public modalRef: NgbModalRef;
  @Output() goBack = new EventEmitter<any>();
  public Object: any;
  public questionType:any;

  constructor(private qiuzeReviewService: QuizReviewService,
    private encriptDecript: EncriptDecriptService,
    private cd: ChangeDetectorRef) {
    this.Object = this.encriptDecript.getLocalStorage('userObject');

  }

  ngOnInit() {
    this.selectedAttemp = this.lessonObject.quizAttempt;
    this.questionType   = this.lessonObject.quizQuestionType;
  }

  ngDoCheck() {
    // check for change in attempt.
    if (!Object.is(this.previousLessonObject,
      this.lessonObject.quizAttempt.attempt)) {
      this.previousLessonObject = this.lessonObject.quizAttempt.attempt;
      this.getQuizReview();
      this.cd.markForCheck();
    }
  }

  private getQuizReview() {
    const user = JSON.parse(this.Object);
    const { launchUrl, quizAttempt } = this.lessonObject;
    this.qiuzeReviewService.getQuizReview(user, quizAttempt, launchUrl).subscribe(
      (res) => {
        this.quizReviewObject = res;
        this.cd.markForCheck();
        this.cd.detectChanges();
      },
      (err) => {
        if (err.status == 401) {
          this.modalRef.close();
        }
      });
  }

  gotoFrontpage(event) {
    this.goBack.emit(false);
  }

  getString(option) {
    var stringArray = option.split('\n');
    for (let j = 0; j <= stringArray.length - 1; j++) {
      var data: string = stringArray[j];
      var length = data.search(/\S/);
      for (let i = 1; i <= length; i++) {
        stringArray[j] = "&nbsp" + stringArray[j];
      }
    }
    return stringArray;
  }

  changeAttempt(attempt) {

    this.quizReviewObject = [];
    const user = JSON.parse(this.Object);
    const launchUrl = this.lessonObject.launchUrl;
    this.qiuzeReviewService.getQuizReview(user, attempt, launchUrl).subscribe(
      (res) => {
        this.quizReviewObject = res;
        this.cd.markForCheck();
        this.cd.detectChanges();
      }, (err) => {
        if (err.status == 401) {
          this.modalRef.close();
        }
      });
  }

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboardcards/charts/quiz-review/quiz-review.component.ts